<template>
  <div @contextmenu.prevent="openContextMenu">
    <feather-icon icon="FilterIcon" :class="actionElementCss" svgClasses="h-5 w-5" @click="openContextMenu" :badge="badge" badgeColor="dark"/>

  <context-menu id="action-board-filter" ref="ctxMenu">


    <ColorPicker v-model="filteredColor" class="mt-2 m-1" @colorChanged="colorChanged" namespace="action-board" :alwaysOpen="true"/>



                        <!-- <li><div style="background-color: red">...<div></div></div> </li> -->
       </context-menu>


  </div>
</template>
<script>

// import { midnight, isPast, daysFromDate } from '@/helpers/date'
export default {
  components: {
  },
  props: [],
  data () {
    return {
      filteredColor: null
    }
  },
  computed: {
    badge () {
      return this.filteredColor ? 1 : 0
    },
    liClases () {
      if (this.disabled) {
        return `disabled opacity-50 ${this.textColor}`
      } else {
        return `cursor-pointer hover:font-semibold hover:bg-grey-light hover:rounded ${this.textColor}`
      }
    },
  },
  methods: {
    colorChanged (color) {
      console.log("color changed", color)
      this.$store.commit('CHANGE_FILTER', { color })
      this.filteredColor = color
    },
    openContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.ctxMenu) {
        this.$refs.ctxMenu.open()
      }
    },
  }
}
</script>

<style scoped>
</style>
